import UwStatusTag from 'components/common/uw-review/UwStatusTag';
import React from 'react';
import { UwResult } from 'types/uwService';
import { observer } from 'mobx-react-lite';
import ProductSummary from '../ProductSummary';
import { RATES_COMPARISON_CARD_TEST_IDS } from '../constants';
import { CardWrapperStyled, ProductNameStyled, RatesBlockStyled, TitleInfoWrapperStyled } from './styles';

interface Props {
  result: UwResult;
  isRenewOrCancelProductLine: boolean;
}

export const RatesComparisonCard: React.FC<Props> = observer(({ result, isRenewOrCancelProductLine }) => {
  return (
    <>
      {result.products.map((product) => {
        return (
          <CardWrapperStyled key={product.name} data-test-id={RATES_COMPARISON_CARD_TEST_IDS.CARD_WRAPPER}>
            <TitleInfoWrapperStyled data-test-id={RATES_COMPARISON_CARD_TEST_IDS.TITLE_INFO_WRAPPER}>
              <ProductNameStyled
                dangerouslySetInnerHTML={{ __html: product.name }}
                data-test-id={RATES_COMPARISON_CARD_TEST_IDS.PRODUCT_NAME}
              />
              <UwStatusTag status={result.eligibilityStatus} />
            </TitleInfoWrapperStyled>
            <RatesBlockStyled data-test-id={RATES_COMPARISON_CARD_TEST_IDS.RATES_BLOCK}>
              <ProductSummary
                key={`productSummary_${product.name}_Quoted`}
                productSummary={product.original}
                rateTitle={isRenewOrCancelProductLine ? 'Current Rates' : 'Quoted Rates'}
                productLineId={result.productLineId}
                isRenewOrCancelProductLine={isRenewOrCancelProductLine}
                sectionRatesQuantity={product.original.rates.length}
                $side="left"
              />
              <ProductSummary
                key={`productSummary_${product.name}_Final`}
                productSummary={product.final}
                rateTitle={isRenewOrCancelProductLine ? 'Renewal Rates' : 'Final Rates'}
                productLineId={result.productLineId}
                eligibilityStatus={result.eligibilityStatus}
                isRenewOrCancelProductLine={isRenewOrCancelProductLine}
                sectionRatesQuantity={product.original.rates.length}
                $side="right"
              />
            </RatesBlockStyled>
          </CardWrapperStyled>
        );
      })}
    </>
  );
});
